import { useRef } from 'react';
import { SelectButton, PopoverSheet } from 'reaxl';
import { jsxs, jsx } from 'react/jsx-runtime';
function SelectButtonWrapper(_ref) {
  let {
    buttonLabel,
    children,
    className,
    disabled,
    heading,
    position,
    primaryLabel,
    secondaryLabel,
    containerElement,
    hideCTA,
    onClick = () => {},
    isActive,
    setIsActive
  } = _ref;
  const buttonRef = useRef(null);
  const clickHandler = () => {
    setIsActive(isInputActive => !isInputActive);
    onClick();
  };
  return /*#__PURE__*/jsxs("div", {
    className: "position-relative",
    children: [/*#__PURE__*/jsx(SelectButton, {
      ref: buttonRef,
      disabled: disabled,
      onClick: clickHandler,
      isActive: isActive,
      primaryLabel: primaryLabel,
      secondaryLabel: secondaryLabel,
      boldSecondaryLabel: false
    }), /*#__PURE__*/jsx(PopoverSheet, {
      show: isActive,
      onClick: () => setIsActive(false),
      heading: heading,
      buttonLabel: buttonLabel,
      className: className,
      containerElement: containerElement,
      position: position,
      hideCTA: hideCTA,
      children: children
    })]
  });
}
export { SelectButtonWrapper as default };
